import { BotId } from '@feedyou/schema'
import { getApiUrl, QueryParams } from '../../../../../apiService'

export const callsListUrlGetters = {
  transcriptForUser: (params: { botId: BotId; userId: string }): string => {
    return getApiUrl(`/bots/${params.botId}/transcript/users/${params.userId}`)
  },
  callLogsForUser: (params: { botId: BotId; userId: string }): string => {
    return getApiUrl(`/bots/${params.botId}/telephony/calls/${params.userId}/logs`)
  },
  callsList: (params: { botId: BotId }, queryParams?: QueryParams): string => {
    return getApiUrl(`/bots/${params.botId}/telephony/calls`, queryParams)
  },
  validatorResultsForStep: (params: { botId: BotId; stepId: string }): string => {
    return getApiUrl(`/bots/${params.botId}/transcript/validator/step/${params.stepId}`)
  },
  validatorResultsForType: (params: { botId: BotId; validatorType: string }): string => {
    return getApiUrl(`/bots/${params.botId}/transcript/validator/type/${params.validatorType}`)
  }
}
